export interface PartialBlockReleaseRequestForm {
	startTime: string;
	endTime: string;
}

export const PartialReleaseRequestDefaultValues: PartialBlockReleaseRequestForm = {
	startTime: '',
	endTime: '',
};
